import RatingComparison from './RatingComparison'

export default RatingComparison
